import axios from 'axios'

/**
 * AUTH STACK
 */
export const login = (user) => axios.post(`/api/auth/login`, user);
export const usernameLogin = (user) => axios.post(`/api/auth/username-login`, user);
export const logout = (token = null) => axios.get(`/api/auth/logout${token ? `?token=${token}` : '' }`);
export const setPassword = (data, token) => axios.post(`/api/set-password/${token}`, data);
export const refreshToken = () => axios.get(`/api/auth/refresh-token`);
export const sendPasswordReset = (body) => axios.post(`/api/send-password-reset`, body)

/**
 * WATCHES STACK
 */
export const getAllWatch = (page = 1, query = {}) => axios.get(`/api/all-watches?page=${page}${Object.entries(query).map(el => `&${el[0]}=${el[1]}`).join('')}`);
export const getWatches = (page = 1, name) => axios.get(`/api/watch-name/${name}?page=${page}`);
export const getWatchDetails = (id) => axios.get(`/api/watch/${id}`);
export const getWatch = (id) => axios.get(`/api/watch/${id}`);
export const getPart = (page = 1, id) => axios.get(`/api/part/${id}?page=${page}`);
export const sendCart = (parts, note, merchant) => axios.post('/api/order/create', { items: parts, note: note, target_username: merchant });

/**
 * BRANDS STACK
 */
export const fetchBrands = (page = 1) => axios.get(`/api/mark/index?page=${page}`);
export const createBrand = (brand) => axios.post(`/api/mark/create`, brand);
export const showBrand = (id) => axios.get(`/api/mark/show/${id}`);
export const updateBrand = (brand) => axios.put(`/api/mark/update/${brand.id}`, brand);
export const deleteBrand = (id) => axios.delete(`/api/mark/delete/${id}`);

/**
 * USERS STACK
 */
export const fetchUsers = (page = 1, search = '') => axios.get(`/api/user/index?page=${page}${search ? `&search=${search}` : ''}`);
export const createUser = (user) => axios.post('/api/user/create', user);
export const updateUser = (user) => axios.put('/api/user/update', user);
export const showUser = (id) => axios.get(`api/user/show/${id}`);
export const deleteUser = (id) => axios.delete(`api/user/delete/${id}`);

/**
 * ORDERS STACK
 */
export const fetchOrders = (page = 1, query = {}) => axios.get(`/api/order/index?page=${page}${Object.entries(query).map(el => `&${el[0]}=${el[1]}`).join('')}`);
export const fetchOrder = (id) => axios.get(`/api/order/show/${id}`);
export const updateOrder = (id, order) => axios.put(`/api/order/put/${id}`, order);
export const deleteOrder = (id) => axios.delete(`/api/order/delete/${id}`);
export const updateMultipleStatus = (selection) => axios.patch(`/api/order/update-status`, selection)

/**
 * SETTINGS STACK
 */
export const uploadExcel = (formData) => axios.post(`/api/load-file`, formData, {
    headers: { 'content-type': 'multipart/form-data' }
});
export const importExl = () => axios.get(`/api/process-import-v2`);


/**
 * ANNOUNCEMENTS STACK
 */
export const storeAnnouncement = (announcement) => axios.post(`/api/announcements/create`, announcement);
export const showAnnouncement = (id) => axios.get(`/api/announcements/show/${id}`);
export const getAnnouncements = (page = 1) => axios.get(`/api/announcements/index?page=${page}`);
export const updateAnnouncement = (announcement) => axios.put(`/api/announcements/update/${announcement.id}`, announcement);
export const deleteAnnouncement = (id) => axios.delete(`/api/announcements/delete/${id}`);
export const uploadFile = (file) => axios.post(`/api/upload-file-ad`, file);

export const refreshImages = () => axios.get(`/api/update-watch-images?storage=${process.env.VUE_APP_STORAGE_DIRECTION}`)
